import { useStaticQuery, graphql } from "gatsby";
import { ProductFields } from "./fragments";

export const UseGetTrendingProducts = () => {
  const data = useStaticQuery(graphql`
    query getAllTrendingProducts {
      BestSeller: shopifyCollection(
        title: { eq: "Best Sellers" }
        products: { elemMatch: { handle: { ne: "shipping-protection" } } }
      ) {
        ...ProductFields
      }
      New: shopifyCollection(
        title: { eq: "New" }
        products: { elemMatch: { handle: { ne: "shipping-protection" } } }
      ) {
        ...ProductFields
      }
    }
  `);
  return data;
};
